/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Modals\ModalMessage\ModalMessage.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday August 2nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 22nd September 2023 01:53:12
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { MouseEventHandler, useEffect, useState, Dispatch, SetStateAction, Fragment, FormEvent } from "react";
import MyModal from "Content/Modals/MyModal";
import {Form, Button, Col} from "react-bootstrap";
import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Modals/ModalPack/ModalPack.module.css";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import MessageService from "Services/Message/MessageService";
import { MessageType } from "Type/message.type";

type ModalProps = {
    show: boolean;
    onClose: MouseEventHandler<HTMLDivElement>;
    closeModal: MouseEventHandler;
    autoClose: Function;
    addNewTemplate: Dispatch<SetStateAction<MessageType | undefined>>;
    title: string;
};

function ModalMessage(props: ModalProps) {
    const [name, setName] = useState("");
    const [isSendable, setIsSendable] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);

    const HandleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setSpinner(true);
        let dataToSend = {
            Name: name,
            Content: `<p>${translator.decode("messages.customizeYourMail")}</p>`
        };
        MessageService.CreateMessage(dataToSend)
        .then((res) => {
            setIsOkay(true);
            props.autoClose();
            var message: MessageType = {
                Content: null,
                Name: name,
                id: res.id
            }
            props.addNewTemplate(message);
            setName("");
            setOpenModal(true);
            setSpinner(false);
        })
        .catch(() => {
            setSpinner(false);
            setOpenModal(true);
        });
    };

    useEffect(() => {
        if (name)
            setIsSendable(true);
        else
            setIsSendable(false);
    }, [name]);

    return(
        <Fragment>
            <MyModal closeModal={props.closeModal} show={props.show} addCloseCross={true} onClose={props.onClose} footer={(() => { return (<></>); })()} title={props.title} className={""}>
                {
                    spinner ?
                        <div className={`${Styles.spinnerHolder}`}>
                            <LoadingScreen />
                        </div>
                        :null
                }
                <Form className={`${Styles.formHolder}`} onSubmit={HandleSubmit}>
                    <Form.Group className={`${Styles.formfield}`} >
                        <Form.Label>
                            {translator.decode("dynamic.name")}
                        </Form.Label>
                        <Col>
                            <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} autoFocus/>
                        </Col>
                    </Form.Group>
                    <Button disabled={!isSendable} className="mb-3" type="submit">{translator.decode("dynamic.create")}</Button>
                </Form>
            </MyModal>
            <ModalConfirmation show={openModal} onClose={() => setOpenModal(false)} closeModal={() => setOpenModal(false)} isOkay={isOkay} />
        </Fragment>
    )
}

export default ModalMessage;
